jQuery(function($) {
  // wraps the header in a wrapper and uses it to keep the document height while
  // the header is affixed
  $('#header').wrap('<div id="header-wrapper"></div>');
  $('#header-wrapper').css('height', $('#header').css('height'));
});
